module.exports = __webpack_public_path__ + "img/main-pic.84672f75.png";